export const NationalBankOfSamoa = "National Bank of Samoa";
export const SamoaCommercialBank = "Samoa Commercial Bank";
export const Frankie = "Frankie";
export const ADBTestBank = "ADB Test Bank";

export const BankNotSupportedMessage = "Your account is not connected to a supported bank";
